// extracted by mini-css-extract-plugin
module.exports = {"loading-screen__page":"loading-screen_loading-screen__page__ex_7c","loading-screen__loader":"loading-screen_loading-screen__loader__S_Jai"};